import Vue from "vue";
import Vuex from "vuex";
import Auth from "./auth.js";
import Edit from "./edit.js";
import Sheet from "./sheet.js";
import Money from "./money.js";
import Food from "./food.js";
import Activity from "./activity.js";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth: Auth,
    edit: Edit,
    sheet: Sheet,
    money: Money,
    food: Food,
    activity: Activity
  }
});

export default store;
